function collapsable() {
    const collapsable = document.querySelectorAll('[data-collapsed]');

    if( collapsable.length > 0 ) {
        collapsable.forEach( element => {
            // console.log({element});
            let trigger = element.querySelector('[data-collapsed-trigger]'),
                element_height = element.offsetHeight,
                content_element = element.querySelector('div:not([data-collapsed-trigger])');

            content_element.style.maxHeight = 'none';
            let content_height = content_element.offsetHeight;
            
            content_element.setAttribute('style', '');

            if( element_height > content_height ) {
                element.classList.add('short');
            }

            trigger.addEventListener('click', (event) => {
                let current = element.getAttribute('data-collapsed');

                if( current == 1 ) {
                    // element.closest('.wp-block-column').querySelectorAll('[data-collapsed="0"]').forEach( element => {
                    //     element.setAttribute('data-collapsed', 1);
                    // });
                    element.setAttribute('data-collapsed', 0);
                } else {
                    element.setAttribute('data-collapsed', 1); 
                }
                               
            });
        });
    }
}

collapsable();